export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/carSellBan.1ef40bce.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};